import React from 'react';

export type BreadcrumbItem = {
  label: string;
  href?: string;
};

export type BreadcrumbsProps = {
  items: BreadcrumbItem[];
};

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => (
  <nav className="text-sm py-6 max-w-7xl mx-auto px-4 bg-transparent" aria-label="Breadcrumb">
    <ol className="flex items-center space-x-2">
      {items.map((item, idx) => (
        <li key={item.label} className="flex items-center">
          {item.href && idx !== items.length - 1 ? (
            <a href={item.href} className="hover:text-teal-200 text-white transition-colors underline" style={{ textShadow: '0 1px 4px rgba(0,0,0,0.5)' }}>
              {item.label}
            </a>
          ) : (
            <span className="text-white font-bold" style={{ textShadow: '0 1px 4px rgba(0,0,0,0.5)' }}>{item.label}</span>
          )}
          {idx < items.length - 1 && <span className="mx-2 text-white" style={{ textShadow: '0 1px 4px rgba(0,0,0,0.5)' }}>/</span>}
        </li>
      ))}
    </ol>
  </nav>
);

export default Breadcrumbs; 